import styles from "../styles/GetAppLanding.module.scss";
import aboundAiImage from "../assets/feature-abound-ai.webp";
import cashbackImage from "../assets/feature-cashback.webp";
import ctaPhone from "../assets/cta-phone.webp";
import downloadIcon from "../assets/downloadIcon.svg";
import earnInterestImage from "../assets/feature-earn-interest.webp";
import { moneyMoveCopy, productSections, stats } from "./landingData";

const featureImages = {
  earn: earnInterestImage,
  ai: aboundAiImage,
  cashback: cashbackImage,
};

const FeatureImage = ({ type, title }) => (
  <div className={styles.featureImage}>
    <img src={featureImages[type]} alt={`${title} app preview`} />
  </div>
);

const ProductFeature = ({ feature, index }) => {
  const reverse = index % 2 === 1;

  return (
    <article
      className={`${styles.productFeature} ${reverse ? styles.productFeatureReverse : ""}`}
      id={feature.id}
    >
      <FeatureImage type={feature.mockup} title={feature.title} />
      <div className={styles.productFeatureCopy}>
        <h3>{feature.title}</h3>
        <p>{feature.description}</p>
        <ul>
          {feature.bullets.map((bullet) => (
            <li key={bullet.label}>
              <img src={bullet.icon} alt="" />
              <span>{bullet.label}</span>
            </li>
          ))}
        </ul>
        {feature.poweredBy && (
          <div className={styles.poweredBy}>
            <img src={feature.poweredBy.image} alt={feature.poweredBy.label} />
          </div>
        )}
      </div>
    </article>
  );
};

const ProductShowcase = () => {
  return (
    <section className={styles.productSection}>
      <section className={styles.moneyMoves} id="money-moves">
        <div className={styles.moneyMovesPanel}>
          <div className={styles.moneyMovesIntro}>
            <h2>Smarter way for Indians in the US to manage money.</h2>
            <p>{moneyMoveCopy}</p>
          </div>
          <div className={styles.statsBand}>
            {stats.map((item) => (
              <div key={item.label}>
                <strong>{item.value}</strong>
                <span>{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={styles.superappSection}>
        <div className={styles.superappIntro}>
          <h2>The Super Money App For NRIs</h2>
          <p>Send, save, track & grow your money, all in one place.</p>
        </div>
        <div className={styles.productFeatures}>
          {productSections.map((feature, index) => (
            <ProductFeature key={feature.id} feature={feature} index={index} />
          ))}
        </div>
      </section>
      <section className={styles.downloadCtaSection}>
        <div className={styles.downloadCtaCard}>
          <div className={styles.downloadCtaCopy}>
            <h2>Send, manage & grow your money with Abound</h2>
            <p>
              Send money to India, earn cashback and grow your savings. All from
              one app.
            </p>
            <a
              className={styles.downloadButton}
              href="https://accounts.joinabound.com/getapp/signup/v2?source=remittance"
            >
              <span>Download Abound</span>
              <span className={styles.downloadIcon} aria-hidden="true">
                <img src={downloadIcon} alt="" />
                {/* <img src={downloadIconArrow} alt="" /> */}
              </span>
            </a>
          </div>
          <div className={styles.downloadCtaArt}>
            <img src={ctaPhone} alt="Abound app features" />
          </div>
        </div>
      </section>
    </section>
  );
};

export default ProductShowcase;
